import Table from "../../common/table";

const TestResult = ({ data }: any) => {
  const TdComponent = ({ children }: any) => {
    return <td className="whitespace-nowrap text-sm">{children}</td>;
  };

  function formatBloodTestData(data: any) {
    const formattedData = data?.map((item: any) => {
      return (
        <tr key={item.component_id}>
          <TdComponent>{item.component_name}</TdComponent>
          <TdComponent>{item.result_value}</TdComponent>
          <TdComponent>{item.status}</TdComponent>
        </tr>
      );
    });

    return formattedData;
  }

  const ResultCard = ({ title, content }: any) => {
    return (
      <div className="bg-pr_yellow p-4 rounded-xl mb-3">
        <h5 className="font-rokh font-[900] mt-2 mb-1">{title}</h5>
        <p className="text-sm">{content}</p>
      </div>
    );
  };

  return (
    <div className="mt-10">
      <h6 className="font-rokh font-[900] mt-2 mb-3 text-lg">
        فایل‌های آزمایش:
      </h6>

      <div className="border flex flex-col lg:flex-row items-start gap-2 p-8 rounded-2xl">
        {data.files.map((record: any) => (
          <img
            key={record.url}
            src={record.url}
            className="max-w-full lg:max-w-[370px] border rounded-sm"
          />
        ))}
      </div>

      <div className="mt-20">
        <h6 className="font-rokh font-[900] mb-3 text-lg">
          فاکتورهای استخراج شده:
        </h6>

        <div className="overflow-x-auto border rounded-xl">
          <Table
            header={["فاکتور", "مقدار", "وضعیت"]}
            body={formatBloodTestData(data.components_result)}
          />
        </div>
      </div>

      <div className="mt-20">
        <h6 className="font-rokh font-[900] mt-2 mb-3 text-lg">
          فاکتورهای نامعتبر:
        </h6>

        {data.invalid_components.name?.length > 0 ? (
          <div className="flex items-center flex-wrap gap-2">
            {data.invalid_components.name.map((invalidComp: any) => (
              <span
                className="bg-gray-100 px-3 py-1 rounded-sm flex-1 text-center"
                key={invalidComp}
              >
                {invalidComp}
              </span>
            ))}
          </div>
        ) : (
          <p>همه فاکتورها استخراج شدن</p>
        )}
      </div>

      <div className="mt-20">
        <h6 className="font-rokh font-[900] mt-2 mb-3 text-lg">
          نتایج هوش‌مصنوعی :
        </h6>

        <div>
          <ResultCard
            title="تحلیل بادی‌بان"
            content={`${data.medical_advice.user_medical_advice}`}
          />
          <ResultCard
            title="آزمایش‌های پیشنهای"
            content={`${data.medical_advice.complementary_tests}`}
          />
          <ResultCard
            title="ارزیابی بادی‌بان"
            content={`${data.medical_advice.health_risk_assessment}`}
          />
          <ResultCard
            title="رژیم و سبک زندگی"
            content={`${data.medical_advice.lifestyle_dietary_advice}`}
          />
          <ResultCard
            title="مدیریت و بهبود"
            content={`${data.medical_advice.management_and_treatment}`}
          />
          <ResultCard
            title="دمنوش و گیاهان دارویی"
            content={`${data.medical_advice.medicinal_plants_herbal_teas}`}
          />
          <ResultCard
            title="ویتامین‌های پیشنهای"
            content={`${data.medical_advice.useful_vitamins}`}
          />
        </div>
      </div>
    </div>
  );
};

export default TestResult;
